// import { useCallback, useState } from "react";
// import { getDataFromStorage,  removeFromStorageByKey, setDataToStorage } from "../Storage/Storage"


// /** 
//     * @Desc
//     * hook to use useState + save it into mmkv (to reduce repeated code) 
// */

// export function usePersistedState<T>({key, initial}:{key: string, initial?: T | null}) {
//   const [state, setState] = useState<T | null>(initial ?? getDataFromStorage(key));

//   const set = useCallback((next: T | null) => {
//     if (next === null) {
//       removeFromStorageByKey(key);
//     } else {
//       // console.log(key + ' JSON.stringify(next): ',  JSON.stringify(next))
//       setDataToStorage(key, JSON.stringify(next));
//     }
//     setState(next);
//   }, [key]);

//   return [state, set] as const;
// }

import { useCallback, useEffect, useRef, useState } from "react";
import {
  getDataFromStorage,
  getDataFromStorageAsync,
  removeFromStorageByKey,
  setDataToStorage,
} from "../Storage/Storage";

type SetterArg<T> = T | null | ((prev: T | null) => T | null);

/**
 * hook to use useState + save it into mmkv (to reduce repeated code)
 */
export function usePersistedState<T>({
  key,
  initial,
  callBack,
  ignoreStorage = false
}: {
  key: string;
  initial?: T | null;
  callBack?: (x: T | null) => any,
  ignoreStorage?: boolean
}) {
  // lazy init to avoid running getDataFromStorage on every render
  const [state, setState] = useState<T | null>(() => {
    const stored = getDataFromStorage(key);
    if (stored !== null && stored !== undefined) return stored as T;
    return initial ?? null;
  });
  const [hydrated, setHydrated] = useState(false);
  const timeOut = useRef<NodeJS.Timeout>(null)

  useEffect(() => {
    let cancelled = false;

    void getDataFromStorageAsync(key).then((stored) => {
      if (cancelled) return;
      if (stored !== null && stored !== undefined) {
        setState((prev) => {
          if (Object.is(prev, stored)) return prev;
          return stored as T;
        });
      }
      setHydrated(true);
    });

    return () => {
      cancelled = true;
    };
  }, [key]);

  const set = useCallback(
    (update: SetterArg<T>) => {
      setState(prev => {
        const next =
          typeof update === "function"
            ? (update as (p: T | null) => T | null)(prev)
            : update;
        if (Object.is(next, prev)) {
          if (callBack) {
            if(timeOut.current){
              clearTimeout(timeOut.current)
            }
            timeOut.current = setTimeout(async () => {
              await callBack(next);
            })
            
          }
          return prev;
        }
        if(key && !ignoreStorage){
          if (next === null) {
            removeFromStorageByKey(key);
          } else {
            setDataToStorage(key, JSON.stringify(next));
          }
        }
        
        // console.log('[usePersistedState]', key, 'prev:', prev, 'next:', next);
        if(callBack)
          callBack(next)
        return next;
      });
      
    },
    [key, callBack, ignoreStorage]
  );

  useEffect(() => {
    return () => {
      if(timeOut.current)
        clearTimeout(timeOut.current)
    }
  },[])
  return [state, set, hydrated] as const;
}



// import { useCallback, useState } from "react";
// import { getDataFromStorage, setDataToStorage } from "../../Storage/Storage";

// type SetStateAction<T> = T | ((prev: T) => T);

// export function usePersistedState<T>({
//   key,
//   initial,
// }: {
//   key: string;
//   initial: T;
// }): readonly [T, (next: SetStateAction<T>) => void] {
//   // Lazy initializer: read storage once on mount
//   const [state, setState] = useState<T>(() => {
//     try {
//       return getDataFromStorage(key) as T;
//     } catch (e) {
//       console.warn(`[usePersistedState] parse failed for "${key}":`, e);
//       return initial;
//     }
//   });

//   const set = useCallback(
//     (next: SetStateAction<T>) => {
//       setState((prev) => {
//         const value = typeof next === "function" ? (next as (p: T) => T)(prev) : next;

//         // Avoid unnecessary writes
//         if (Object.is(value, prev)) return prev;

//         try {
//           setDataToStorage(key, JSON.stringify(value));
//         } catch (e) {
//           console.warn(`[usePersistedState] write failed for "${key}":`, e);
//         }

//         return value;
//       });
//     },
//     [key]
//   );

//   return [state, set] as const;
// }


// type SetStateAction<T> = T | ((prev: T) => T);

// export function usePersistedState<T>({
//   key,
//   initial,
// }: {
//   key: string;
//   initial: T;
// }): readonly [T, (next: SetStateAction<T>) => void] {
//   const [state, setState] = useState<T>(() => {
//     try {
//       return getDataFromStorage(key);
//     } catch {
//       return initial;
//     }
//   });

//   const set = useCallback(
//     (next: SetStateAction<T>) => {
//       setState((prev) => {
//         const value = typeof next === "function" ? (next as (p: T) => T)(prev) : next;
//         try {
//           setDataToStorage(key, JSON.stringify(value));
//         } catch {}
//         return value;
//       });
//     },
//     [key]
//   );

//   return [state, set] as const;
// }
